import * as Sentry from '@sentry/react';

const ShutdownSentry = () => {
  try {
    Sentry.close();
  } catch (e) {
    console.error(e);
  }
};

export default ShutdownSentry;
